import {
    SignalInfo,
    ApplicationType,
    FeatureName,
    lazyPostPersonalizationUsageSignals,
    getUsageSuggestions,
} from 'owa-personalization';

export default function sendInitialHintSeenSignal(): void {
    if (getUsageSuggestions(FeatureName.Sonora)) {
        const ghostTextSeenSignal = 'GhostTextSeen';
        const signals: SignalInfo[] = [];

        // Count of action is 1
        signals[ghostTextSeenSignal] = 1;

        lazyPostPersonalizationUsageSignals.importAndExecute(
            signals,
            [],
            ApplicationType.Mail,
            FeatureName.Sonora
        );
    }
}
